export default [
    {
        title: 'FAQs',
        icon: 'HelpCircleIcon',
        tagVariant: 'light-warning',
        route: 'pages-faq'
    },
]
